import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Text from '../Text';
import type { IRadioInputProps } from './IRadioInputProps';

const RadioInput = forwardRef<HTMLInputElement, IRadioInputProps>(
  (props, forwardedRef) => {
    const {
      title,
      description,
      icon: Icon,
      iconUrl,
      className,
      labelClassName,
      ...rest
    } = props;

    if (Icon && iconUrl) {
      throw new Error('Radio Input cannot use both icon and iconUrl');
    }

    return (
      <div className="flex w-full items-center">
        <label
          className={twMerge(
            'border-retail-gray-400 flex w-full items-center gap-3 rounded-xl border px-6 py-5 md:h-14 h-12',
            labelClassName
          )}
          htmlFor={rest.id}
        >
          {Icon || null}
          {iconUrl ? (
            <img
              src={iconUrl}
              alt="radio-input-image"
              height={48}
              width={48}
              className="h-12 w-12"
              loading="eager"
            />
          ) : null}
          <span>
            <Text variant="h5">{title}</Text>
            {description ? (
              <p className="text-mobile-gray-400 mt-1 block">{description}</p>
            ) : null}
          </span>
          <input
            className={twMerge(
              'accent-retail-primary-700 text-retail-primary-700 h-5 w-5 ml-auto',
              className
            )}
            type="radio"
            ref={forwardedRef}
            {...rest}
          />
        </label>
      </div>
    );
  }
);

RadioInput.displayName = 'RadioInput';

export default RadioInput;
